module.exports = __webpack_public_path__ + "img/img-download-google-play.9062e40.svg";